<template>
    <el-drawer
        :title="!id ? '新增图片信息' : '编辑图片信息'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                v-loading="dataLoading"
            >
                <el-form-item prop="imgUri" label="上传图片:">
                    <image-upload 
                        :url.sync="formData.imgUri" 
                        :urlFull.sync="formData.imgUri" 
                        @onSuccess="handleImageSuccess"
                    ><span slot="size">无特殊要求</span></image-upload>
                </el-form-item>
                <el-form-item prop="imgName" label="名称:">
                    <el-input
                        v-model="formData.imgName"
                        placeholder="请输入名称"
                        size="medium"
                        maxlength="40"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="enable" label="状态:">
                    <el-radio-group v-model="formData.enable" size="medium">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item  v-if="type===1" prop="useRule" label="使用规则:">
                    <el-radio-group v-model="formData.useRule" size="medium">
                        <el-radio :label="0">系统模板</el-radio>
                        <el-radio :label="1">指定背景图</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import ImageUpload from '@/components/ImageUpload'
const defaultFormData = {
    imgName: "",
    enable:1,
    bmp:'',
    imgUri:'',
    useRule: 0
}
export default {
    props:{
        dataList:{
            type:Array,
            default: () => []
        }
    },
    components:{
        ImageUpload
    },
    data() {
        return {
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },
            rules: {
                imgName: [{ required: true, message: "请输入名称" }],
                imgUri: [{ required: true, message: "请上传图片" }],
            },
            id:'',
            type: null
        };
    },
    methods: {
        close() {
            this.formData = {...defaultFormData};
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(data) {
            const {id, type} = data || {};
            this.id = id;
            this.type = type;
            if(this.id){
                this.getDataDetail();
            }
            this.drawerShow = true;
        },
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/img/depot/getById",
                params: { id: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData = {
                            ...result,
                        };
                    } else {
                        self.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    self.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //表单提交
        submitForm() {
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {

                    const _nameFlag = this.dataList.find( v => v.imgName == this.formData.imgName);
                    if( !this.id && _nameFlag ){
                        return this.$message.error('已有其他图片使用了该名称');
                    }

                    const _url = this.id
                        ? "/img/depot/update"
                        : "/img/depot/create";
                    this.btnLoading = true;

                    this.$request({
                        url: _url,
                        data: {...this.formData, type: this.type},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('update');
                                self.close();
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },

        handleImageSuccess(file){
            const _type = file.file.type, _name = file.file.name;
            this.formData.bmp = _type.substring(_type.lastIndexOf('/')+1);
            this.formData.imgName = _name;
            this.$refs["formData"].clearValidate('imgUri');
        }
    },
};
</script>

<style lang="scss" scoped>

</style>